// 브라우저가 감지한 IANA 타임존(예: "Asia/Seoul"). 가입 시 기본값으로 서버에
// 보내고, 설정 페이지에서 저장된 값이 없을 때의 폴백으로도 쓴다.
export function detectTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
